module.exports = __webpack_public_path__ + "img/cloud-computing.c6953ef6.png";